/* The Homely Habit - cart drawer tweaks, recommendations, and recently viewed loader */
(function () {
  var LIMIT = 6;
  var busy = false;

  /* Styles for the recently viewed row (rendered by hh-recent.js) */
  var css = '.hh-rv{max-width:var(--page-width,1200px);margin:0 auto;padding:56px 20px 72px;box-sizing:border-box}'
    + '.hh-rv__title{margin:0 0 24px;font-size:clamp(22px,2.4vw,32px);font-weight:500}'
    + '.hh-rv__grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:20px}'
    + '@media(max-width:749px){.hh-rv__grid{grid-template-columns:repeat(2,minmax(0,1fr))}.hh-rv{padding:40px 16px 56px}}'
    + '.hh-rv__card{text-decoration:none;color:inherit;display:block}'
    + '.hh-rv__img{width:100%;aspect-ratio:1;object-fit:cover;display:block;background:#f2f2f2}'
    + '.hh-rv__name{margin:12px 0 2px;font-size:0.9375rem;line-height:1.35}'
    + '.hh-rv__price{margin:0;font-size:0.9375rem;opacity:0.7}'
    /* Reassurance badges at the top of the cart drawer */
    + '.hh-badges{display:flex;align-items:flex-start;justify-content:center;gap:40px;'
    + 'padding:18px var(--cart-drawer-padding,20px) 16px;'
    + 'border-bottom:1px solid rgba(17,17,17,0.12)}'
    + '.hh-badges__item{display:flex;flex-direction:column;align-items:center;gap:8px;'
    + 'text-align:center;flex:0 1 auto;max-width:130px}'
    + '.hh-badges__icon{width:32px;height:32px;flex:0 0 32px;border:1px solid currentColor;'
    + 'border-radius:50%;display:flex;align-items:center;justify-content:center;color:#111111}'
    + '.hh-badges__icon svg{width:14px;height:14px;display:block}'
    + '.hh-badges__label{margin:0;font-size:11px;line-height:1.3;letter-spacing:0.08em;'
    + 'text-transform:uppercase;opacity:0.7}'
    + '@media(max-width:480px){.hh-badges{gap:28px}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* Load the recently viewed script on product pages only */
  if (/\/products\//.test(window.location.pathname)) {
    var s = document.createElement('script');
    s.src = window.__hhRecentSrc || '/cdn/shop/t/hh-recent.js';
    s.defer = true;
    if (window.__hhRecentSrc) document.head.appendChild(s);
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
    } catch (e) { return '£' + (cents / 100).toFixed(2); }
  }

  function thumb(url) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_112x112_crop_center$1$2');
  }

  function badgeItem(label) {
    var item = document.createElement('div');
    item.className = 'hh-badges__item';

    var icon = document.createElement('span');
    icon.className = 'hh-badges__icon';
    icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">'
      + '<path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" stroke-width="2.5"'
      + ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
    item.appendChild(icon);

    var p = document.createElement('p');
    p.className = 'hh-badges__label';
    p.textContent = label;
    item.appendChild(p);

    return item;
  }

  function injectBadges() {
    var inner = document.querySelector('#cart-drawer .cart-drawer__inner');
    if (!inner) return;
    if (inner.querySelector('.hh-badges')) return;
    var items = inner.querySelector('cart-items-component');
    if (!items) return;

    var row = document.createElement('div');
    row.className = 'hh-badges';
    row.appendChild(badgeItem('Free UK delivery'));
    row.appendChild(badgeItem('30-day returns'));
    inner.insertBefore(row, items);
  }

  function relabel() {
    var scopes = document.querySelectorAll('#cart-drawer, .cart-page, .cart-summary');
    [].forEach.call(scopes, function (scope) {
      var w = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        if (/Estimated total/i.test(n.nodeValue)) {
          n.nodeValue = n.nodeValue.replace(/Estimated total/gi, 'Subtotal');
        }
      }
      var label = scope.querySelector('.cart-totals__total-label');
      if (!label) return;
      var row = label.parentElement;
      while (row && !row.querySelector('.cart-totals__total-value')) row = row.parentElement;
      if (!row || !row.parentNode) return;
      if (row.parentNode.querySelector('.hh-free-delivery')) return;
      var p = document.createElement('p');
      p.className = 'hh-free-delivery';
      p.textContent = 'Free UK delivery on every order';
      row.parentNode.insertBefore(p, row.nextSibling);
    });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer-section')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var host = document.getElementById('shopify-section-cart-drawer-section');
        if (!host) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#shopify-section-cart-drawer-section') || tmp.firstElementChild;
        if (!fresh) return;
        host.replaceWith(fresh);
        var dlg = document.querySelector('#cart-drawer dialog');
        if (dlg && !dlg.open) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
        inject();
      });
  }

  function addVariant(id, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
  }

  function build(products, inCart) {
    var wrap = document.createElement('div');
    wrap.className = 'hh-recs';

    var head = document.createElement('div');
    head.className = 'hh-recs__head';
    var h = document.createElement('p');
    h.className = 'hh-recs__title';
    h.textContent = 'You may also like';
    head.appendChild(h);
    var hint = document.createElement('p');
    hint.className = 'hh-recs__hint';
    hint.textContent = 'Swipe for more';
    head.appendChild(hint);
    wrap.appendChild(head);

    var row = document.createElement('div');
    row.className = 'hh-recs__row';
    var shown = 0;

    products.forEach(function (p) {
      if (shown >= LIMIT) return;
      if (inCart.indexOf(p.id) !== -1) return;
      var available = (p.variants || []).filter(function (v) { return v.available; });
      if (!available.length) return;

      var item = document.createElement('div');
      item.className = 'hh-recs__item';

      var tl = document.createElement('a');
      tl.className = 'hh-recs__thumb';
      tl.href = p.url;
      var img = document.createElement('img');
      img.className = 'hh-recs__img';
      img.loading = 'lazy';
      img.alt = p.title;
      if (p.featured_image) img.src = thumb(p.featured_image);
      tl.appendChild(img);
      item.appendChild(tl);

      var meta = document.createElement('div');
      meta.className = 'hh-recs__meta';
      var nm = document.createElement('a');
      nm.className = 'hh-recs__name';
      nm.href = p.url;
      nm.textContent = p.title;
      meta.appendChild(nm);
      var pr = document.createElement('p');
      pr.className = 'hh-recs__price';
      pr.textContent = money(p.price);
      meta.appendChild(pr);
      item.appendChild(meta);

      if (available.length === 1) {
        var btn = document.createElement('button');
        btn.className = 'hh-recs__add';
        btn.type = 'button';
        btn.textContent = 'Add';
        btn.setAttribute('aria-label', 'Add ' + p.title + ' to cart');
        btn.addEventListener('click', function () { addVariant(available[0].id, btn); });
        item.appendChild(btn);
      } else {
        var link = document.createElement('a');
        link.className = 'hh-recs__add';
        link.href = p.url;
        link.textContent = 'Add';
        link.setAttribute('aria-label', 'Add ' + p.title + ' - choose a size');
        item.appendChild(link);
      }

      row.appendChild(item);
      shown++;
    });

    if (!shown) return null;
    wrap.appendChild(row);

    if (shown > 1) {
      var dots = document.createElement('div');
      dots.className = 'hh-recs__dots';
      for (var i = 0; i < shown; i++) {
        var dot = document.createElement('span');
        dot.className = 'hh-recs__dot' + (i === 0 ? ' hh-recs__dot--on' : '');
        dots.appendChild(dot);
      }
      wrap.appendChild(dots);
      row.addEventListener('scroll', function () {
        var idx = Math.round(row.scrollLeft / row.clientWidth);
        [].forEach.call(dots.children, function (d, i) {
          d.className = 'hh-recs__dot' + (i === idx ? ' hh-recs__dot--on' : '');
        });
      });
    } else {
      hint.textContent = '';
    }

    return wrap;
  }

  function inject() {
    relabel();
    injectBadges();
    var summary = document.querySelector('#cart-drawer .cart-drawer__summary');
    if (!summary) return;
    if (document.querySelector('#cart-drawer .hh-recs')) return;
    if (busy) return;
    busy = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { busy = false; return; }
        var inCart = cart.items.map(function (i) { return i.product_id; });
        var seed = cart.items[0].product_id;
        return fetch('/recommendations/products.json?product_id=' + seed + '&limit=12&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var node = build(data.products || [], inCart);
            var target = document.querySelector('#cart-drawer .cart-drawer__summary');
            if (node && target && !document.querySelector('#cart-drawer .hh-recs')) {
              target.parentNode.insertBefore(node, target);
            }
            busy = false;
          });
      })
      .catch(function () { busy = false; });
  }

  var obs = new MutationObserver(function () { inject(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', inject);
  inject();
})();
